import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { API } from '@/constants/bluemonk';

export const RevisionModal = ({ open, onOpenChange, item, actor, headers, onSuccess }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestRevision = async () => {
    if (!actor) {
      toast.error('Please select your identity first');
      return;
    }

    if (!reason.trim()) {
      toast.error('Please provide a reason for the revision request');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/deliverables/${item.id}/request-revision`, {
        actor,
        reason
      }, { headers });

      toast.success('Revision requested');
      onSuccess();
      setReason('');
    } catch (error) {
      console.error('Revision request error:', error);
      toast.error('Failed to request revision. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!item) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>Request Revision</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div>
            <p className="font-medium text-slate-900">{item.title}</p>
          </div>

          <div>
            <Label>Reason for revision *</Label>
            <Textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Please describe what changes are needed..."
              rows={4}
              className="mt-1"
              required
            />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button 
              onClick={handleRequestRevision} 
              disabled={loading || !reason.trim()}
            >
              {loading ? 'Submitting...' : 'Request Revision'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
